/** Only suited for components which span entire width of browser window. */
export const CONTENT_CONTAINER_STYLES = 'w-[90vw] md:w-[85vw] xl:w-[80vw] max-w-[66rem] mx-auto'
